const COLORS = {
  white: '#FFFFFF',
  backgroundGrey: '#F5F5F5',
  borderGrey: '#D7D7D7',
  borderGreyDark: '#d2d2d2',
  grey: '#757575',
  lightGrey: '#808080',
  hoverGrey: '#cdcbcb2b',
  menuChoiceGrey: '#555555',
  searchGrey: '#e4e4e4',
  lightBlack: '#181818',
  mediumDarkGrey: 'rgba(0, 0, 0, 0.49)',
  lightDarkGrey: 'rgba(0, 0, 0, 0.38)',
  darkGrey: 'rgba(0, 0, 0, 0.55)',
  black: '#000000',

  lightOrange: '#e0726e29',
  salmon: '#f9e3e2',
  orange: '#E0726E',
  coral: '#E06E5C',
  coralDark: '#D15A48',
  darkerOrange: '#EF6C00',
  darkOrange: '#ffc107',
  blue: '#096BDE',
  subscriptionBlue: '#2196F3',
  lightBlue: '#2fb8d4',
  opacBlue: '#F4FAFF',
  lightGreen: '#83B061',
  green: '#66bb6a',

  lightRed: '#bf360c',
  red: '#C62828',
  redDark: '#A51F1F',
  redDeep: '#4A1616',
  redTint: '#FAEEEE',
  errorRed: '#f44336',

  purple: '#9077E7',
  // Live-stream status palette (from the design system's danger/warning/purple ramps)
  liveRed: '#F04E63',
  liveRedTint: '#FDE2E6',
  liveRedDeep: '#8E2130',
  pausedAmber: '#F5A623',
  broadcastPurple: '#5138C4',
  broadcastPurpleLight: '#B0A1FE',
  broadcastPurpleTint: '#F4F1FF',
  darkYellow: '#FFBC7D',
  bisque: '#fad3b2',
}
export default COLORS
